// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hnkwi","fixedBackground":"styles_fixedBackground__hUXt0"};